import styled from 'styled-components';
import { Col, Space, Table, Typography, Checkbox } from 'antd';

import colors from '../../../../../styles/colors';

const { Text } = Typography;

export const CollapseContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  border-radius: 2px;
  border: none;
  padding: 0 18px;
  margin: 0;
`;

export const CollapseHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerActions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .text-id {
    color: #828282;
    font-size: 14px;
    line-height: 20px;
    width: 100%;
  }
  div.ant-typography,
  .ant-typography p {
    margin: 0;
    min-width: 213px;
    .ant-typography-copy {
      color: #24a95d;
    }
  }
`;

export const ColTitleCollapse = styled(Col)`
  flex-direction: column;
  width: 28%;
  padding: 0;
  align-items: flex-start;
  .content-id {
    border: none;
    background-color: #f2f2f2;
    padding: 4px 16px;
    height: 40px;
    width: 100%;
    border-radius: 2px;
  }
  .style-input-nome {
    font-size: 14px;
    color: #bdbdbd;
    background-color: #f2f2f2;
    padding-left: 8px;
    border-radius: 2px;
    border: none;
    width: 100%;
    height: 40px;
    text-align: left;
  }
  .text-title {
    font-size: 14px;
    font-weight: bold;
    color: #707070;
    margin-bottom: 8px;
    width: 100%;
  }
`;

export const ContainerControl = styled.div`
  display: flex;
  flex-direction: row;
`;

export const RotationIcon = styled.div`
  .openCollaps {
    transform: rotate(0deg);
    transition: transform 400ms ease-in-out;
    cursor: pointer;
  }
  .openCollaps.active {
    transform: rotate(180deg);
    transition: transform 400ms ease-in-out;
    cursor: pointer;
  }
`;

export const CollapseBody = styled.div`
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.6s ease-out;
`;

export const CollapseContent = styled.div`
  margin: 70px 0 0 0;
`;

export const AddItem = styled(Space)`
  margin: 0 4%;
  color: ${props => (props.event ? colors.lightGrey : colors.verde)};
  font-size: 16px;
  line-height: 19px;
  text-decoration: ${props =>
    props.event
      ? `underline ${colors.lightGrey}`
      : `underline ${colors.verde}`};
  cursor: pointer;
  pointer-events: ${props => (props.event ? 'none' : 'auto')};
`;

export const ContainerTable = styled.div`
  width: 100%;
  overflow: none;
  height: 330px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const TableCustom = styled(Table)`
  width: 100%;
  .ant-table-container {
    background-color: #ffffff;
  }
  .ant-table-thead ::before {
    display: none;
  }
  .ant-table-thead > tr > th {
    border: none;
    background-color: #ffffff;
    color: ${colors.greyText};
  }
  .ant-table-header {
    margin-bottom: 12px !important;
  }
  .ant-table-thead > tr > th {
    border-bottom: 2px solid #cacaca;
    background-color: ${colors.branco};
    color: ${colors.greyText};
    :nth-last-child(-n + 1) {
      border-bottom: none;
    }
  }
  .ant-table-tbody > tr > td {
    background-color: #ffffff;
    border-bottom: none;
    font-size: 14px;
    color: #828282;
  }
  .ant-table-pagination.ant-pagination {
    display: none;
  }
`;

export const TitleTable = styled(Text)`
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: ${colors.greyText};
`;

export const RowContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const RowActions = styled.div`
  width: 46%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;

export const CheckboxCustom = styled(Checkbox)``;
